<template>
  <div class="input-field select-active">
    <material-select id="status_form" name="status" @input="handleInput" :multiple="multiple" v-model="content">
      <option disabled selected value="">Qualquer status</option>
      <option v-for="status in status_formularios" :value="status">{{ status }}</option>
    </material-select>
    <label for="status_form">{{label}}</label>
  </div>
</template>

<script>
  export default {
    name: "SelectStatus",
    props: {
      value: {
        default: null
      },
      label: {
        default: 'Status'
      },
      multiple: {
        default: false
      }
    },
    data() {
      return {
        content: this.value,
        status_formularios: [
          'lead', 'lead_site',
          'renovacao', 'a_ser_visitado', 'rascunho', 'com_pendencia', 'com_pendencia_assessor',
          'em_analise_analista', 'mesa_credito', 'aprovado',
          'aprovado_desembolso', 'desembolsado', 'nao_desembolsado', 'recusado',
          'sem_interesse', 'sem_contato', 'inativo'
        ]
      }
    },
    updated() {
      if (typeof Materialize.updateTextFields !== 'undefined') {
        Materialize.updateTextFields();
      }
    },
    methods: {
      handleInput(e) {

        this.$emit('input', this.content)
      }
    },
    computed: {
      isMultiple() {
        return this.multiple ? 'multiple' : null
      }
    }
  }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// resources/assets/js/components/common/SelectStatus.vue